import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAccessibility } from '../hooks/useAccessibility';

const faqs = [
  {
    q: 'Como funciona o app CONECTAR?',
    a: 'O CONECTAR é um aplicativo desenvolvido especialmente para crianças autistas que oferece ferramentas de comunicação alternativa, jogos educativos, desenho com IA, música personalizada e rotinas visuais.',
  },
  {
    q: 'O CONECTAR é gratuito?',
    a: 'Sim! O CONECTAR oferece uma versão gratuita com recursos essenciais, além de planos premium com funcionalidades avançadas.',
  },
  {
    q: 'O app é seguro para crianças?',
    a: 'Sim. Seguimos normas rigorosas de segurança infantil: sem anúncios, sem coleta desnecessária de dados e com controle total para os pais.',
  },
  {
    q: 'O app funciona offline?',
    a: 'Boa parte das funcionalidades funciona offline. Recursos com IA, como reconhecimento de desenhos e música personalizada, exigem conexão com a internet.',
  },
  {
    q: 'Como acompanhar o progresso da criança?',
    a: 'O app gera relatórios automáticos com a evolução em comunicação, coordenação motora e reconhecimento de formas e letras.',
  },
];

const FAQPreviewSection = () => {
  const { speak } = useAccessibility();
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="relative py-20 md:py-28 bg-muted/30">
      <div className="container mx-auto px-6 max-w-3xl">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-10 text-center">
          Perguntas frequentes
        </h2>

        <div className="divide-y divide-border/60 border-t border-b border-border/60">
          {faqs.map((faq, index) => {
            const isOpen = open === index;
            return (
              <div key={faq.q}>
                <button
                  onClick={() => {
                    setOpen(isOpen ? null : index);
                    speak(isOpen ? 'Fechar resposta' : faq.q);
                  }}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left"
                >
                  <span className="font-medium text-lg text-foreground">{faq.q}</span>
                  <ChevronDown
                    className={`w-5 h-5 text-muted-foreground flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isOpen && (
                  <p className="text-base text-muted-foreground leading-relaxed pb-5 pr-8">{faq.a}</p>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/faq"
            className="inline-flex items-center gap-1.5 text-base font-semibold text-primary hover:underline"
          >
            Ver todas as perguntas
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQPreviewSection;
